export const getStyles = ({ MeControl = {} }, { palette = {} }) => {
  const defaultDropdownContainer = {
    height: 'calc(100vh - 60px)',
    width: 460,
    boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
    backgroundColor: palette.neutralLighterAlt,
    left: 'auto',
    right: 0,
    borderRadius: 0,
    '& > .react-focus-lock': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  };

  const defaultAvatarInProfileCard = {
    height: 80,
    width: 80,
    borderRadius: 40,
    margin: '17px 28px 46px 35px',
  };

  const defaultAvatarInToggleButton = {
    height: 28,
    width: 28,
    borderRadius: 14,
  };

  const defaultDropdownTitleContainer = {
    height: 50,
    fontSize: 20,
    padding: {
      top: 10,
      left: 16,
      right: 26,
    },
    flex: 'none',
  };

  const defaultProfileCard = {
    maxHeight: 200,
    minHeight: 143,
    backgroundColor: palette.white,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.132)',
    borderRadius: 2,
    width: '100%',
    display: 'flex',
  };

  const defaultCustomerSelectorContainer = {
    padding: {
      left: 16,
      right: 26,
    },
    flexShrink: 1,
    overflow: 'hidden',
    overflowY: 'auto',
  };

  const defaultProfileCardRightSection = {
    verticalAlign: 'top',
    margin: '17px 35px 26px 0',
    wordBreak: 'break-word',
  };

  const defaultProfileCardLink = {
    paddingTop: 10,
    display: 'block',
  };
  return {
    dropdownContainer: { ...defaultDropdownContainer, ...MeControl.dropdownContainer },
    avatarInProfileCard: { ...defaultAvatarInProfileCard, ...MeControl.avatarInProfileCard },
    avatarInToggleButton: { ...defaultAvatarInToggleButton, ...MeControl.avatarInToggleButton },
    dropdownTitleContainer: {
      ...defaultDropdownTitleContainer,
      ...MeControl.dropdownTitleContainer,
    },
    profileCard: {
      ...defaultProfileCard,
      ...MeControl.profileCard,
    },
    customerSelectorContainer: {
      ...defaultCustomerSelectorContainer,
      ...MeControl.customerSelectorContainer,
    },
    profileCardRightSection: {
      ...defaultProfileCardRightSection,
      ...MeControl.profileCardRightSection,
    },
    profileCardLink: {
      ...defaultProfileCardLink,
      ...MeControl.profileCardLink,
    },
    dropdown: {
      height: '100%',
      width: '100%',
      maxWidth: 246,
    },
    dropdownNew: {
      display: 'flex',
      alignItems: 'center',
    },
    dropdownButton: {
      height: '100%',
      width: '100%',
      padding: '0px !important',
      backgroundColor: palette.globalBackground,
      borderRadius: 'unset',
      border: 'none',
      color: '#fff !important',
      minWidth: 1,
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'none',
        border: 'none !important',
        backgroundColor: `${palette.themeDarkAlt} !important`,
      },
      '&:active, &:focus': {
        textDecoration: 'none',
        border: 'none !important',
        outline: 'none !important',
        backgroundColor: `${palette.neutralLighterAlt} !important`,
        color: `${palette.neutralPrimary} !important`,
        '&:after': {
          border: 'none !important',
        },
      },
    },
    dropdownButtonNew: {
      borderRadius: '4px',
      backgroundColor: 'transparent',
      marginRight: '12px !important',
      height: '48px',
      color: '#424242 !important',
      '&:hover': {
        border: 'none !important',
        backgroundColor: '#F5F5F5 !important',
        color: `${palette.themePrimary} !important`,
      },
      '&:active, &:focus': {
        textDecoration: 'none',
        border: 'none !important',
        outline: 'none !important',
        backgroundColor: `${palette.neutralLighterAlt} !important`,
        color: `${palette.themeDarker} !important`,
        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 0px 2px 0px, rgba(0, 0, 0, 0.14) 0px 2px 4px 0px, rgb(0, 0, 0) 0px 0px 0px 2px',
        '&:after': {
          border: 'none !important',
        },
      },
    },
    dropdownCloseButton: {
      position: 'absolute',
      top: 20,
      right: 20,
      cursor: 'pointer',
    },
    breadcrumbContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      height: '100%',
      width: '100%',
    },
    userInfoContainer: {
      display: 'flex',
      flexDirection: 'column',
      lineHeight: '19px',
      textAlign: 'right',
      margin: '12px 0px 9px 5px',
      width: 'calc(100% - 52px)', // 52px is width of avatar
      justifyContent: 'center',
    },
    userInfoContainerNew: {
      alignItems: 'flex-start',
      paddingRight: '12px',
      marginTop: '0px',
      marginBottom: '0px',
      width: 'auto',
      minWidth: '0px',
      flex: '1 1 0px',
    },
    userLine: {
      color: 'inherit',
      fontSize: 12,
      paddingRight: 1,
      lineHeight: '16px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },
    customerLine: {
      width: '100%',
      overflow: 'hidden',
      color: 'inherit',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    customerName: {
      fontSize: 14,
      fontWeight: 'bold',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      float: 'left',
    },
    customerId: {
      fontSize: 12,
      padding: '1px 2px 0px 2px',
    },
    bottomChevronDown: {
      color: 'inherit',
      margin: '0 !important',
      top: '0 !important',
      fontSize: '12px !important',
      lineHeight: '12px !important',
    },
    avatarInBreadcrumbContainer: {
      width: 28,
      height: 28,
      margin: '16px 12px 16px 11px',
      alignSelf: 'center',
    },
    avatarInBreadcrumbContainerNew: {
      width: 20,
      height: 20,
      margin: '0px 12px 0px 11px',
      alignSelf: 'center',
      '& svg': {
        width: 20,
        height: 20,
      },
    },
    avatarInBreadcrumb: {
      borderRadius: 14,
      height: 28,
      width: 28,
    },
  };
};

